<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h1>Login</h1>
            <!--   {{Logout()}} -->
                <p class="text-muted">Connectez-vous à votre compte</p>
                <CInput
                  v-model="userid"
                  placeholder="Utilisateur"
                  autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  v-model="passwd"
                  placeholder="mot de passe"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton color="primary" class="px-4" v-on:click="() => CheckLogin()">Login</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <!--
                    <CButton color="link" class="px-0">Forgot password?</CButton>
                    <CButton color="link" class="d-md-none">Register now!</CButton>
                    -->
                  </CCol>
                </CRow>
                 <strong>{{Responses}} </strong>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
           <img style="height:120px;width:221px;float:left;" src="../../assets/images/SN_logo.png"/>
          <!--
            <h2>Sign up</h2>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
            <CButton
              color="primary"
              class="active mt-3"
            >
              Register Now!
            </CButton>
            -->
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>

const APIURL = process.env.VUE_APP_API_URL
import axios from 'axios'

export default {
  name: 'Login',
  data() 
  {
    return {
      userid: "",
      passwd: "",
      Responses: ""
    }
  },
  methods: 
  {
    Logout: function()
    {
        this.$store.commit('set', [ 'Authorized', false ]  );
        console.log('login.vue:Logout(): this.$store.state.Authorized = ',this.$store.state.Authorized)
    },
    CheckLogin: function ()
    {
    //  console.log('CheckLogin():'+APIURL+'/api1/users?userId='+this.userid+','+this.passwd);
        this.$store.commit('set', [ 'Authorized', false ]  );
        axios.get( APIURL+'/api1/users?userId='+this.userid+','+this.passwd, {   
         mode: 'no-cors',
              headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          withCredentials: false
        } )
        .then( res =>
        {
          if (res.data != null)
          {
            this.$store.commit('set', [ 'Authorized', true ]  );
            this.$store.state.Authorize=true;
            console.log('login.vue:CheckLogin(): this.$store.state.Authorized = ',this.$store.state.Authorized)
            var location = '/dashboard'
            this.$router.replace('/')
            this.$nextTick(() => this.$router.replace(location))
          }
          else
          {
            this.Responses = 'Mauvais utilisateur/mot de passe'
          }
        } )
        .catch( err => {
        //      console.log(err)          
                if (err.response.status ==403)
                      this.Responses = 'Mauvais utilisateur/mot de passe'
                else
                {
                  this.Responses = 'Erreur survenue! ['+err+']';
                  console.log(err)            
                }
            }
          )
        .finally(() => this.loading = false) 
      


    }
  }
}
</script>
